$(function(){
  var active_audio_url;
  $('.playAudioClick').on('click', function(){
    $('.playAudio').css('display','block');
    $('.playAudioInner').css('display','block');
    active_audio_url = $(this).find('.getAudioUrl').html();
    $('.playAudioInner').html(`<audio src="${active_audio_url}" controls controlslist="nodownload" preload="metadata"></audio><div class="backgroundBlur"></div>`);
  });
});
